const removeTime = date => date.split('T')[0]

const Day = ({ value }) => {
  const date = new Date(removeTime(value))

  return date.toLocaleDateString('fi-FI')
}

export default Day
